/* ==============================================
 * Custom JS — Vanilla JS + Swiper
 * Replaces jQuery + Slick Carousel + jQuery Marquee
 * ============================================== */
(function () {
  'use strict';

  /* ---------- Utility helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /** Lazy-init helper: runs callback when element enters viewport */
  var lazyObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var cb = entry.target._lazyInit;
            if (cb) { cb(); delete entry.target._lazyInit; }
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px' })
    : null;

  function lazyInit(el, callback) {
    if (!el) return;
    if (!lazyObserver) { callback(); return; }
    el._lazyInit = callback;
    lazyObserver.observe(el);
  }

  /** Delegated event listener */
  function on(type, selector, handler) {
    document.addEventListener(type, function (e) {
      var el = e.target.closest(selector);
      if (el) handler.call(el, e);
    });
  }

  /** Convert a plain container into Swiper-compatible markup */
  function swiperize(container) {
    if (!container) return null;
    if (container.classList.contains('swiper')) return container;
    container.classList.add('swiper');
    if (!container.querySelector('.swiper-wrapper')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
      while (container.firstChild) {
        var child = container.firstChild;
        if (child.nodeType === 1) child.classList.add('swiper-slide');
        wrapper.appendChild(child);
      }
      container.appendChild(wrapper);
    }
    return container;
  }

  /** Inject prev/next navigation buttons */
  function addNav(container) {
    var prev = document.createElement('div');
    prev.className = 'swiper-button-prev';
    var next = document.createElement('div');
    next.className = 'swiper-button-next';
    container.appendChild(prev);
    container.appendChild(next);
    return { nextEl: next, prevEl: prev };
  }

  /** Inject pagination element */
  function addPagination(container) {
    var pag = document.createElement('div');
    pag.className = 'swiper-pagination';
    container.appendChild(pag);
    return { el: pag, clickable: true };
  }

  /* ============================================
   * Product Card Swatches
   * ============================================ */
  on('change', '.swatches--product-card li input', function () {
    var wrapper = this.closest('.product-card__wrapper');
    if (!wrapper) return;
    qsa('.swatches--product-card li input', wrapper).forEach(function (i) { i.checked = false; });
    this.checked = true;
    var inp = qs('form .product-variant-id', wrapper);
    if (inp) inp.value = this.dataset.variant_id;
  });

  /* ============================================
   * Marquee (pure CSS animation)
   * ============================================ */
  function initMarquee() {
    qsa('.marquee').forEach(function (el) {
      if (el.classList.contains('marquee--animated')) return;
      var html = el.innerHTML;
      el.innerHTML =
        '<span class="marquee__inner">' + html + '</span>' +
        '<span class="marquee__inner" aria-hidden="true">' + html + '</span>';
      el.classList.add('marquee--animated');
      el.addEventListener('mouseenter', function () { this.classList.add('marquee--paused'); });
      el.addEventListener('mouseleave', function () { this.classList.remove('marquee--paused'); });
    });
  }

  /* ============================================
   * Column count helper
   * ============================================ */
  function initColumnCount() {
    var items = qsa('.multicolumn-grid-cont .multi-items');
    var grid = qs('.multicolumn-grid-cont');
    if (!grid) return;
    if (items.length === 3) grid.classList.add('column-3');
    else if (items.length === 5) grid.classList.add('column-5');
  }

  /* ============================================
   * Press Slider (main + thumbnails)
   * ============================================ */
  function initPressSlider() {
    var mainEl = qs('.press-slider');
    var thumbEl = qs('.press-slider-thumb');
    if (!mainEl || !thumbEl) return;

    swiperize(thumbEl);
    var pag = addPagination(thumbEl);
    var thumbSwiper = new Swiper(thumbEl, {
      slidesPerView: 2,
      spaceBetween: 10,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      pagination: pag,
      breakpoints: {
        577: { slidesPerView: 3 },
        769: { slidesPerView: 5 }
      }
    });

    swiperize(mainEl);
    new Swiper(mainEl, {
      slidesPerView: 1,
      thumbs: { swiper: thumbSwiper }
    });
  }

  /* ============================================
   * Bundle Products Slider
   * ============================================ */
  function initBundleSlider() {
    var el = qs('.bundle-include .bundle-included');
    if (!el) return;
    swiperize(el);
    var nav = addNav(el);
    new Swiper(el, {
      slidesPerView: 3,
      spaceBetween: 10,
      navigation: nav
    });
  }

  /* ============================================
   * Product Tabs Slider
   * ============================================ */
  var tabsSwiper = null;

  function initTabsSlider() {
    var el = qs('.custom_product_tabs .product-list-desktop');
    if (!el) return;
    if (tabsSwiper) { tabsSwiper.destroy(true, true); tabsSwiper = null; }

    swiperize(el);
    if (!el.querySelector('.swiper-button-next')) addNav(el);

    tabsSwiper = new Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 13,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        769: { slidesPerView: 4 }
      }
    });
  }

  /* ============================================
   * Video play / pause helper
   * ============================================ */
  function playPauseVideo(swiper, action) {
    if (!swiper || !swiper.slides) return;
    var slide = swiper.slides[swiper.activeIndex];
    if (!slide) return;
    var video = slide.querySelector('video');
    if (video) { action === 'play' ? video.play() : video.pause(); }
  }

  /* ============================================
   * Review Videos Slider
   * ============================================ */
  function initReviewVideos() {
    var el = qs('.review-videos-inner');
    if (!el) return;
    swiperize(el);
    var nav = addNav(el);

    new Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: { delay: 7000 },
      navigation: nav,
      breakpoints: {
        577: { slidesPerView: 3 },
        769: { slidesPerView: 5 }
      },
      on: {
        afterInit: function (s) { setTimeout(function () { playPauseVideo(s, 'play'); }, 1000); },
        slideChangeTransitionStart: function (s) { playPauseVideo(s, 'pause'); },
        slideChangeTransitionEnd: function (s) { playPauseVideo(s, 'play'); }
      }
    });
  }

  /* ============================================
   * Popup Video Sliders (main + thumbnails)
   * ============================================ */
  function initPopupVideoSliders() {
    var mainEl = qs('.popup-slider-videos');
    var thumbEl = qs('.popup-slider-videos-thumbnails');
    if (!mainEl || !thumbEl) return;

    swiperize(thumbEl);
    var thumbNav = addNav(thumbEl);
    var thumbSwiper = new Swiper(thumbEl, {
      slidesPerView: 3,
      spaceBetween: 11,
      direction: 'vertical',
      autoplay: { delay: 7000 },
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      navigation: thumbNav
    });

    swiperize(mainEl);
    new Swiper(mainEl, {
      slidesPerView: 1,
      direction: 'vertical',
      autoplay: { delay: 7000 },
      thumbs: { swiper: thumbSwiper },
      on: {
        afterInit: function (s) { setTimeout(function () { playPauseVideo(s, 'play'); }, 1000); },
        slideChangeTransitionStart: function (s) { playPauseVideo(s, 'pause'); },
        slideChangeTransitionEnd: function (s) { playPauseVideo(s, 'play'); }
      }
    });
  }

  /* ============================================
   * Slider nav click → open popup overlay
   * ============================================ */
  on('click', '.slider-nav .swiper-slide', function (e) {
    e.preventDefault();
    var overlay = qs('.popup__overlay');
    if (overlay) overlay.classList.add('model-active');
    document.body.classList.add('video-model-open');
  });

  /* ============================================
   * Modal close
   * ============================================ */
  on('click', '.model-close', function () {
    var overlay = qs('.popup__overlay');
    if (overlay) overlay.classList.remove('model-active');
    document.body.classList.remove('video-model-open');
  });

  /* ============================================
   * Cart drawer button
   * ============================================ */
  on('click', '.cart-drawer-button', function (e) {
    e.preventDefault();
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.setAttribute('open', '');
      drawer.setAttribute('active', '');
      drawer.removeAttribute('hidden');
      drawer.removeAttribute('inert');
    }
  });

  /* ============================================
   * Custom variant picker
   * ============================================ */
  on('change', '.custom_variant_picker', function () {
    var wrap = this.closest('.button_with_variants');
    if (!wrap) return;
    var inp = wrap.querySelector('form input[name="id"]');
    if (inp) inp.value = this.value;
  });

  /* ============================================
   * Free Gift button
   * ============================================ */
  on('click', '.free-gift-button', function () {
    var btn = this;
    var giftId = btn.dataset.variant_id;
    btn.classList.add('btn--loading');

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: giftId, quantity: 1, sections: window.FoxKitSections, section_url: window.location.pathname })
      });
    }).then(function (r) { return r.json(); }).then(function (parsed) {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        cart.sections = parsed.sections;
        cart.section_url = parsed.section_url;
        if (window.FoxTheme && FoxTheme.pubsub) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
        }
        var c = qs('.custom-free-gift-container');
        if (c) c.classList.add('hidden');
        btn.classList.remove('btn--loading');
      });
    });
  });

  /* ============================================
   * Free product visibility check
   * ============================================ */
  function updatedFreeProduct() {
    var ids = qsa('.free-gift-button').map(function (b) { return parseInt(b.dataset.variant_id); });
    var serumId = parseInt(document.body.dataset.freeSerumOn);

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var inCart = cart.items.some(function (i) { return ids.includes(i.variant_id); });
      var hasSerum = cart.items.some(function (i) { return i.variant_id === serumId; });
      var c = qs('.custom-free-gift-container');
      if (!c) return;
      if (inCart) c.classList.add('hidden');
      else if (hasSerum) c.classList.remove('hidden');
      else c.classList.add('hidden');
    });
  }

  /* ============================================
   * Buy Now (subscription-aware)
   * ============================================ */
  on('change', '.appstle_subscription_wrapper .appstle_select', function () {
    var btn = qs('.custom-buy-now');
    if (btn) btn.dataset.sellingId = this.value;
  });

  on('click', '.buy-now .custom-buy-now', function (e) {
    e.preventDefault();
    var variantId = parseInt(this.dataset.variantId);
    var planInput = qs('.appstle_subscription_wrapper input[name="selling_plan"]:checked');
    var sellingPlanId = planInput ? planInput.value : null;

    var payload = { items: [{ id: variantId, quantity: 1 }] };
    if (sellingPlanId) payload.items[0].selling_plan = sellingPlanId;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        console.error('Error adding product to cart:', err);
        alert('There was a problem adding the product. Please try again.');
      });
  });

  /* ============================================
   * Mega Menu sidebar hover
   * ============================================ */
  on('mouseenter', '.side_bar_menu .mega-menu__item', function () {
    var id = this.dataset.list;
    qsa('.side_bar_menu .mega-menu__item').forEach(function (el) { el.classList.remove('active'); });
    qsa('.side_bar_menu .mega-menu__item_content').forEach(function (el) { el.classList.remove('active'); });
    this.classList.add('active');
    var target = document.getElementById(id);
    if (target) target.classList.add('active');
  });

  /* ============================================
   * Bundle product click
   * ============================================ */
  on('click', '.product-top .product-image', function () {
    var inner = this.closest('.inner-top');
    if (!inner) return;
    var form = inner.querySelector('.product-bottom form');
    if (!form) return;
    var vEl = form.querySelector('[name="variant"]');
    var sEl = form.querySelector('[name="section"]');
    if (vEl && sEl && window.BundleBuilder) {
      window.BundleBuilder.showMoreModal(parseInt(vEl.value), parseInt(sEl.value));
    }
  });

  /* ============================================
   * Boot
   * ============================================ */
  document.addEventListener('DOMContentLoaded', function () {
    initMarquee();
    initColumnCount();
    updatedFreeProduct();

    /* Init above-fold sliders immediately */
    initReviewVideos();

    /* Lazy-init below-fold sliders when they scroll into view */
    lazyInit(qs('.press-slider'), initPressSlider);
    lazyInit(qs('.bundle-include .bundle-included'), initBundleSlider);
    lazyInit(qs('.custom_product_tabs .product-list-desktop'), initTabsSlider);
    lazyInit(qs('.popup-slider-videos'), initPopupVideoSliders);

    /* Tab click → re-init tabs slider */
    on('click', '.custom_product_tabs .tabs__tab', function () {
      setTimeout(initTabsSlider, 300);
    });
  });
})();
